import { AppConfig, ExternalConfig } from './ExternalConfig'

export class AppConfigImpl implements AppConfig {
    constructor(
        public externalConfig: ExternalConfig,
        public gitHash: string,
        public gitRef: string,
        private appVersion: string,
        private mfAppsJson?: string,
    ) {}

    get environmentName() {
        return this.externalConfig.environmentName
    }

    get version() {
        return this.appVersion
    }

    get mfApps(): { name: string; version: string }[] | undefined {
        if (this.mfAppsJson) {
            return JSON.parse(this.mfAppsJson)
        }
        return undefined
    }

    get apiUrl() {
        return this.externalConfig.apiUrl
    }

    get mapUrl() {
        return this.externalConfig.mapUrl
    }

    get isLogging() {
        return this.externalConfig.logging
    }

    get firebaseConfig() {
        return this.externalConfig.firebase
    }

    get sentryUrl() {
        return this.externalConfig.sentryUrl
    }

    get iosAppUrl() {
        return this.externalConfig.iosAppUrl
    }

    get androidAppUrl() {
        return this.externalConfig.androidAppUrl
    }

    get origin() {
        return this.externalConfig.originUrl
    }

    get corsProxyUrl() {
        return this.externalConfig.corsProxyUrl
    }

    get analyticsKey() {
        return this.externalConfig.analyticsKey
    }

    get wsOrigin() {
        if (this.origin) {
            return this.origin.replace(/^http/, 'ws')
        }
        return undefined
    }

    get keycloakConfig() {
        return this.externalConfig.keycloakConfig
    }

    get theme() {
        return this.externalConfig.theme
    }

    get name() {
        return this.externalConfig.name
    }

    get supportEmail() {
        return this.externalConfig.supportEmail ?? ''
    }

    get privacyPolicyUrl() {
        return this.externalConfig.privacyPolicyUrl ?? ''
    }

    get flightTableAppUrl() {
        return this.externalConfig.flightTableAppUrl
    }

    get kanbanAppUrl() {
        return this.externalConfig.kanbanAppUrl
    }

    get taskTemplatesAppUrl() {
        return this.externalConfig.taskTemplatesAppUrl
    }

    get widgetManagementAppUrl() {
        return this.externalConfig.widgetManagementAppUrl
    }
}
